import axiosClient from '../configs/axios';


class DeliveryChallanService {
    // Get list 
    async getDeliveryChallanList(params) {
        try {
           
        const login_details = sessionStorage.getItem("loginUser");
        const userD = JSON.parse(login_details);
        const userInfo = userD?.result?.userInfo;
        

        const unit_id = userInfo?.depot_id || userInfo?.plant_id ;
            const response = await axiosClient.get(
                `/delivery-challan/list?page=${params.page}&size=${params.size}&searchKey=${params.searchKey}&depot_id=${params.depot_id}&unit_id=${unit_id}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }


    // REPORT 

    async  getChallanReport(params) {
    try {
        const login_details = sessionStorage.getItem("loginUser");
        const userD = JSON.parse(login_details);
        const userInfo = userD?.result?.userInfo;
        const unit_id = userInfo?.depot_id || userInfo?.plant_id;
        let { fromDate, toDate, searchKey = '', page = 0, size = 10 } = params;

        // Validate input dates
        if (!fromDate || !toDate) {
            throw new Error("Both fromDate and toDate are required");
        }

        // Convert to Date objects and validate
        const fromDateObj = new Date(fromDate);
        const toDateObj = new Date(toDate);

        if (isNaN(fromDateObj.getTime()) || isNaN(toDateObj.getTime())) {
            throw new Error("Invalid date format for fromDate or toDate");
        }

        // Ensure toDate is not before fromDate
        if (toDateObj < fromDateObj) {
            throw new Error("toDate cannot be before fromDate");
        }

        // Format the dates to yyyy/mm/dd
        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}/${month}/${day}`;
        };

        // Format dates
        const formattedFromDate = formatDate(fromDateObj);
        const formattedToDate = formatDate(toDateObj);

        // Make API call
        const response = await axiosClient.get(
            `/delivery-challan/reports?unit_id=${unit_id}&fromDate=${formattedFromDate}&toDate=${formattedToDate}&searchKey=${searchKey}&page=${page}&size=${size}`
        );
        return response.data;
    } catch (error) {
        console.error("Error in delivery-challan:", error.message);
        throw error;
    }
}













    async getDeliverycylindernoList(depot_id) {
        try {
            const response = await axiosClient.get(
                `/delivery-challan/getcylinder?depot_id=${depot_id}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async getDeliveryChallandepotList(depot_id) {
        try {
            const response = await axiosClient.get(
                `/delivery-challan/customdepot?depot_id=${depot_id}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async getDeliveryChallanCustomerList(depot_id) {
        try {
            const response = await axiosClient.get(
                `/delivery-challan/customcustomer?depot_id=${depot_id}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }








    // Add 
    async addDeliveryChallan(data) {
        try {
            const response = await axiosClient.post('/delivery-challan/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeleteDeliveryChallan(data) {
        try {
            const response = await axiosClient.put(`/delivery-challan/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async editDeleteDeliveryChallanUnbook(data) {
        try {
            const response = await axiosClient.put(`/delivery-challan/unbook`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new DeliveryChallanService(); 